export default {
    select: "Wybierz adres wysyłki",
    shippingRulesTip: "Musisz przestrzegać lokalnych przepisów dotyczących wysyłki"
}